export class DeleteManagerBoard {
  public static readonly type = '[Project/Manager/List] DeleteBoardAction';
  constructor(public readonly id: string) {}
}
